import { WalkI } from './../../interfaces/Walk';
import { CurrentWalkState } from './../types/currentWalkTypes';
import { SET_CURRENT_WALK, OPEN_CURRENT_WALK, CLOSE_CURRENT_WALK } from '../constants/index';
import { AnyAction } from 'redux';

const initialState: CurrentWalkState = {
  walk: {} as WalkI,
  isOpen: false
}

const currentWalkReducer = (state = initialState, action: AnyAction) => {
  const payload = action.payload;

  switch(action.type){
    case SET_CURRENT_WALK:
      // console.log('set current:', payload)
      return {
        ...state,
        walk: payload,
        isOpen: true
    }

    case OPEN_CURRENT_WALK:
      return {
        ...state,
        walk: state.walk,
        isOpen: true
      }

    case CLOSE_CURRENT_WALK:
      return {
        ...state,
        walk: state.walk,
        isOpen: false
      }
        
    default: 
      return state
  }
}

export default currentWalkReducer;
